import { vec2, vec3 } from "gl-matrix";

export function isVec3(v: any): v is vec3 {
  return (Array.isArray(v) || v instanceof Float32Array) && v.length === 3;
}

export function isVec2(v: any): v is vec2 {
  return (Array.isArray(v) || v instanceof Float32Array) && v.length === 2;
}

export function lerpVec3Eased(
  ease: (t: number) => number,
  a: vec3,
  b: vec3,
  t: number,
): vec3 {
  return vec3.lerp(vec3.create(), a, b, ease(t));
}
